export type NodeFilterState = {
  outcomeId: string | null;
};

export const emptyNodeFilters: NodeFilterState = {
  outcomeId: null,
};
